import { Modal } from "antd";
import React from "react";
import styles from "./index.module.scss";
import { FailIcon } from "@/config/config";
import { CommonNormalBtn, CommonPrimaryBtn } from "@/components/CommonBtn";
import { useRouter } from "next/router";
import useDispatchAction from "@/hooks/useDisptachAction";
import { setUserInfo } from "@/redux/actions/home";
import Link from "next/link";
import host from "@/utils/host";


const CancelAuthModal = ({ show, onCancel }) => {
  const router = useRouter();
  const dispatchAction = useDispatchAction({ setUserInfo });
  return <Modal title={null} centered footer={null} width={618} open={show} onCancel={() => {
    onCancel();
  }}>
    <div>
      <div className={styles.create_link_page}>
        <img src={FailIcon} className={"w-[60px] h-[60px] text-left"} />
        <ul style={{ listStyleType: "disc" }} className={"px-[20px]"}>
          <li>
            <div className={"mt-[28px] text_222 text-[14px] text-left"} style={{ color: "#FF6A00", fontWeight: "bold" }}>
              Attention! Please make sure that the TikTok account you logged in on your webpage or App is the same as the one you logged in at anyStarr, otherwise the cancelling will fail!
            </div>
          </li>
          <li>
            <div className={"text_222 text-[14px] text-left mt-[10px]"}>
              After canceling the authorization, many functions will be  <span className={"font-bold "}> disabled </span>. Do you confirm to cancel the authorization?
            </div>
          </li>
        </ul>
        <div className={"flex items-center gap-[48px] w-full mt-[28px]"}>
          <Link target={"_blank"} href={`${host}/api/v2/tiktok/login`} className={"w-full"}>
            <CommonNormalBtn onClick={() => {
              router.push("/");
              onCancel();
            }}>Yes</CommonNormalBtn>
          </Link>
          <CommonPrimaryBtn onClick={() => onCancel()}>No</CommonPrimaryBtn>
        </div>

      </div>
    </div>
  </Modal>;

};

export default CancelAuthModal;
